import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from 'process';
import { Observable, ObservableLike } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RMO_ClientMapping, RMO_ClientMeta, RMO_Property, RMO_PropertyMapping } from '../models/rentManager';
import { YardiClientMapping, YardiClientMeta, YardiPropertyConfiguration, YardiPropertyMapping } from '../models/yardi';


@Injectable({
  providedIn: 'root'
})
export class IntegrationsService {

  constructor(public http: HttpClient) { }

  //RMO:

  GetRMOPropertiesForClient(clientId: number): Observable<RMO_Property[]> {
    return this.http.get<RMO_Property[]>(environment.baseURl + `/api/RentManager/locations/${clientId}`);
  }
  
  GetRMOLocationMappings(clientID: number): Observable<RMO_PropertyMapping[]> {
    return this.http.get<RMO_PropertyMapping[]>(environment.baseURl + `/api/RentManager/assignments/${clientID}`);
  }

  GetRMOClientMapping(clientId: number): Observable<RMO_ClientMapping> {
    return this.http.get<RMO_ClientMapping>(environment.baseURl + `/api/RentManager/${clientId}`);
  }

  GetRMOClientMeta(clientId: number): Observable<RMO_ClientMeta> {
    return this.http.get<RMO_ClientMeta>(environment.baseURl + `/api/RentManager/meta/${clientId}`);
  }
  SaveRMOPropertyMappings(maps: RMO_PropertyMapping[]): Observable<any> {
    return this.http.post<RMO_PropertyMapping[]>(environment.baseURl + `/api/RentManager/assignments`, maps);
  }

  SaveRMOClientMapping(corpId: string, clientId: number): Observable<any> {
    return this.http.get(environment.baseURl + `/api/RentManager/connect/${clientId}/${corpId}`);
  }

  //YARDI:

  SaveYardiClientMapping(mapping: YardiClientMapping): Observable<YardiClientMapping> {
    return this.http.post<YardiClientMapping>(environment.baseURl + '/api/yardi/client', mapping);
  }

  UpdateYardiClientMapping(mapping: YardiClientMapping): Observable<boolean> {
    return this.http.put<boolean>(environment.baseURl + '/api/yardi/client', mapping);
  }

  GetYardiClientMapping(riqClientId: number): Observable<YardiClientMapping> {
    return this.http.get<YardiClientMapping>(environment.baseURl + '/api/yardi/client/' + riqClientId);
  }

  GetYardiPropertiesForClient(clientId: number) : Observable<YardiPropertyConfiguration[]> {
    return this.http.get<YardiPropertyConfiguration[]>(environment.baseURl + '/api/yardi/locations/' + clientId);
  }
  SaveYardiPropertyMappings(yardiMappings: YardiPropertyMapping[]) : Observable<any> {
    return this.http.post(environment.baseURl + '/api/yardi/location-mappings', yardiMappings);
  }
  GetYardiPropertyMappings(clientId: number) : Observable<YardiPropertyMapping[]> {
    return this.http.get<YardiPropertyMapping[]>(environment.baseURl + '/api/yardi/location-mappings/' + clientId);
  }

  GetYardiClientMeta(clientId: number) : Observable<YardiClientMeta> {
    return this.http.get<YardiClientMeta>(environment.baseURl + '/api/yardi/meta/' + clientId);
  }


}
